import { Button, Stack } from '@mui/material'
import { FieldArray, FormikProvider, useFormik } from 'formik'
import { isEmpty, map } from 'lodash'
import { FC, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useWrapperStore } from '../../../store/storeWrapper'

const AssistantShopSidebar: FC = () => {
    const { assistantFiltersList } = useWrapperStore((state) => state)
    const [searchParams, setSearchParams] = useSearchParams()

    const initialValues = useMemo(() => {
        return {
            selectedOptions:
                map(searchParams.getAll('category_ids'), (item) => parseInt(item)) || [],
        }
    }, [searchParams])

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: ({ selectedOptions }) => {
            searchParams.delete('category_ids')

            selectedOptions.forEach((option) => {
                searchParams.append('category_ids', String(option))
            })

            setSearchParams(searchParams)
        },
    })

    const handleClickReset = () => {
        if (isEmpty(searchParams.getAll('category_ids'))) {
            return
        }

        searchParams.delete('category_ids')

        setSearchParams(searchParams)

        formik.resetForm()
    }

    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FieldArray name="selectedOptions">
                    {({ push, remove }) => (
                        <div
                            style={{
                                width: '100%',
                                overflowX: 'auto',
                                marginBottom: '28px',
                            }}>
                            <Stack
                                direction="row"
                                sx={{
                                    width: 'max-content',
                                    minWidth: '100%',
                                    marginBottom: '28px',
                                    gap: '8px',
                                    justifyContent: 'space-between',
                                }}>
                                <Button
                                    onClick={handleClickReset}
                                    sx={{
                                        width: '100%',
                                        color: '#000',
                                        border:
                                            formik.values.selectedOptions.length === 0
                                                ? '1px solid #006CFD'
                                                : '1px solid #F6F6F6',
                                        background:
                                            formik.values.selectedOptions.length === 0
                                                ? '#CCE6FA'
                                                : '#F6F6F6',
                                        lineHeight: 1.2,
                                        padding: 3,
                                    }}
                                    variant="outlined">
                                    Все
                                </Button>
                                {map(assistantFiltersList.available_categories, ({ id, name }) => {
                                    const isChecked = formik.values.selectedOptions.includes(id)

                                    return (
                                        <>
                                            <Button
                                                sx={{
                                                    width: '100%',
                                                    color: '#000',
                                                    border: isChecked
                                                        ? '1px solid #006CFD '
                                                        : '1px solid #F6F6F6',
                                                    background: isChecked ? '#CCE6FA' : '#F6F6F6',
                                                    lineHeight: 1.2,
                                                    padding: 3,
                                                }}
                                                variant="outlined"
                                                onClick={(e) => {
                                                    if (!isChecked) {
                                                        push(id)
                                                    } else {
                                                        const index =
                                                            formik.values.selectedOptions.indexOf(
                                                                id,
                                                            )
                                                        remove(index)
                                                    }
                                                    formik.handleSubmit()
                                                }}>
                                                {name}
                                            </Button>
                                        </>
                                    )
                                })}
                            </Stack>
                        </div>
                    )}
                </FieldArray>
            </form>
        </FormikProvider>
    )
}

export default AssistantShopSidebar
